<template>
    <v-col cols="12" lg="6" class="pa-0 pt-4 pl-0">
        <v-card class="flex pa-0 background-2 round-card fill-height" v-if="!$store.getters.progress">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">{{ title }}</p>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon class="ml-2" small v-bind="attrs" v-on="on">info_outline</v-icon>
                    </template>
                    <span>{{ tooltip }}</span>
                </v-tooltip>                
                <v-spacer></v-spacer>
			    <v-row class="pa-0 ma-0 pr-4">
                    <v-text-field class="hidden-xs-only font-weight-regular"
                        append-icon="search"
                        label="Cerca"
                        v-model="search"
                        clearable
                        hide-details
                        background-color="background-2"
                        outlined
                        dense               
                    ></v-text-field>
			    </v-row>
                <template v-if="createOpportunity">
                    <opportunity-campaign-dialog
                        :items="items"
                        :campaignId="id"
                        :button="{
                            params: {
                                icon: 'mdi-briefcase-plus-outline',
                                tooltip: 'Crea Opportunità',                                
                            }
                        }">
                    </opportunity-campaign-dialog>
                </template>
                <v-tooltip top v-if="createMailingList">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2" v-on="on" @click.native.stop="openDialogCreateMailingList = true" icon>
                            <v-icon>mdi-email-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Crea Mailing List</span>
                </v-tooltip>
                <v-tooltip top v-if="deleteRecipients">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2" v-on="on" @click.native.stop="openDialog = true" icon>
                            <v-icon>cancel_schedule_send</v-icon>
                        </v-btn>
                    </template>
                    <span>Disabilita indirizzi</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2" v-on="on" @click.native.stop="$eventBusUtility.openFile($store, url + '-csv/' + id, title + '.csv', 'POST')" icon>
                            <v-icon>play_for_work</v-icon>
                        </v-btn>
                    </template>
                    <span>Download</span>
                </v-tooltip>
            </v-card-title>                
            <v-divider></v-divider>

            <v-container class="py-0" fluid>
                <v-row class="ma-0">
				    <v-col cols="12" class="hidden-sm-and-up pa-3">
                        <v-text-field
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>

            <v-data-table
				:options.sync="pagination"
			    :server-items-length="totalItems"
                :search="search"
                class="background-2"
                :headers="headers"
                :items="items"
                :mobile-breakpoint="0">
                <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                    <tr class="cursor-pointer">
                        <template v-for="(header, h) in headers">
                            <td v-if="header.type === 'date'" :key="h">
                                <div>
                                    {{ item[header.value] | date }}
                                </div>
                            </td>
                            <td v-else :key="h">
                                {{ item[header.value] }}
                            </td>                        
                        </template>
                    </tr>
                </template>
                <template v-slot:footer.page-text="{ pageStart, pageStop }">
                    Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="openDialogCreateMailingList" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2">Crea nuova Mailing List</v-card-title>
				<v-divider></v-divider>
                <v-card-text class="pt-4 body-2">Crea nuova Mailing List e aggiungi questi contatti automaticamente.</v-card-text>
                <v-card-text>
				    <v-text-field class="pa-4" ref="name" required v-model="mailingListName" :data-vv-name="'Nome Mailing List'" label="Nome Mailing List*" outlined dense v-validate="'required'" :error-messages="errors.collect('Nome Mailing List')"></v-text-field>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click.native.stop="openDialogCreateMailingList = false">Annulla</v-btn>
                    <v-btn text color="info" @click.native.stop="confirmsCreateMailingList()" :loading="loading">Conferma</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="openDialog" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2">Disabilita indirizzi email</v-card-title>
				<v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">Assegna lo stato di questi indirizzi come 'Invalido', in questo modo non saranno più inviate email a questi indirizzi</v-card-text>
				<slot></slot>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click.native.stop="openDialog = false">Annulla</v-btn>
                    <v-btn text color="info" @click.native.stop="confirmsInvalidationRecipients()" :loading="loading">Conferma</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>        
    </v-col>  
</template>

<script>

import OpportunityCampaignDialog from '@/components/modules/mailmarketing/OpportunityCampaignDialog'

export default {
    components: {
        OpportunityCampaignDialog
    },
    name: 'campaign-analytics-recipients',
    props: {
        id: Number,
        url: String,
        title: String,
        headers: Array,
        tooltip: String,
        deleteRecipients: Boolean,
        createMailingList: Boolean,
        createOpportunity: Boolean,
    },

    data() {
        return {
            loading: false,
            search: '',
            items: [],
            totalItems: 0,
            openDialog: false,
            openDialogCreateMailingList: false,
            mailingListName: '',
            pagination:  {
                'sortBy': ['id'],
                'sortDesc': [false],
                'page': 1,
                'itemsPerPage': 10,
                'totalItems': 0,
            },
        }
    },

	watch: {
        pagination: {
            handler() {
                this.getData()
            },
            deep: true,
        },

        search: {
            handler() {
                if(this.pagination.page !== 1) {
                    this.$set(this.pagination, 'page', 1)
                }
                this.getData()
            }
        },
    },    

    methods: {

        getData() {

            if(this.apiTimeout) {
                clearTimeout(this.apiTimeout)
            }

            this.apiTimeout = setTimeout(() => {
                this.loading = true
                    
                let dataObject = {
                    page: this.pagination.page,
                    per_page: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy,
                    sortDesc: this.pagination.sortDesc,
                    filter: this.search,
                }

                this.axios.post(this.url + '/' + this.id, dataObject).then(response => {
                    this.loading = false
                    this.items = response.data.data.data
                    this.totalItems = response.data.data.total

                }, response => {
                    // error callback
                    this.loading = false
                })
            }, 500)
        },

        confirmsCreateMailingList() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return false
                }
                this.loading = true
                this.axios.post('company-maillists-from-active-recipents', {name: this.mailingListName, campaign_id: this.id}).then(response => {
                    this.loading = false
                    let data = response.data
                    let snackmessage = ''
                    let snackcolor = ''
                    if(data.status == 'message'){
                        snackmessage = data.message
                        snackcolor = 'warning'
                    } else{
                        snackmessage = 'Mailing List creata con successo.'
                        snackcolor = 'success'
                    }
                    this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
                    this.openDialogCreateMailingList = false

                    if(data.status == 'success'){
                        // redirect to mailing list with id from response
                        this.$router.push({name: 'maillists-show', params: {id: parseInt(data.id)}})
                    }
                }, response => {
                    // error callback
                    this.loading = false
                })
            })
        },

        confirmsInvalidationRecipients() {
            this.loading = true
            let type = this.url.includes('bounced') ? 'bounced' : 'undelivered'
            this.axios.get('invalidation-recipients/' + this.id, { params: { type } }).then(response => {
                this.loading = false
                let data = response.data
                let snackmessage = ''
                let snackcolor = ''
                if(data.status == 'message'){
                    snackmessage = data.message
                    snackcolor = 'warning'
                } else{
                    snackmessage = 'Elemento aggiornati con successo.'
                    snackcolor = 'success'
                }
                this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
                this.openDialog = false
            }, response => {
                // error callback
                this.loading = false
            })            
        }
    }    
}
</script>

<style>

</style>